import ClientAgent from 'assets/js/clientAgent.js'

export const MixinSap = {
  data () {
    return {
      seznamStrank: [],
      clientAgent: null,
      sap: ''
    }
  },
  methods: {
    GetSap () {
      let param = ['permissionId=STRANKE']
      this.clientAgent.postWsRequest(
        this,
        'permissions/havePermission?',
        param,
        null,
        'SetSap',
        'ErrSap')
    },
    SetSap (podatki) {
      this.seznamStrank = []
      this.seznamStrank = podatki.permission.additionalData
      if (this.seznamStrank.length > 0) {
        this.sap = podatki.permission.additionalData[0].id_stranka_sap
      }
    },
    ErrSap (podatki) {
      this.ShowWarningMessage(podatki)
    }
  }
}

export const UserInfoAgent = {
  data () {
    return {
      clientAgent: null
    }
  },
  methods: {
    GetUserInfo () {
      this.clientAgent = new ClientAgent()
      this.clientAgent.t2Auth.handleAuthentication(this)
    }
  }
}




// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/MixinGetSap.js